export const isSuggestedOnSameTargetAsExpected = (
  target: string,
  expected: number,
  suggested: number
): boolean => {
  const thresholds = target.split("/").map((s) => Number(s.trim()));

  if (thresholds.length === 1 || expected === suggested) {
    return true;
  }

  const bracketOf = (value: number) => {
    const reached = thresholds.filter((t) => value >= t).length;
    return Math.max(reached, 1);
  };

  return bracketOf(expected) === bracketOf(suggested);
};
